import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationInterface } from '../../core/models/notification.model';
import { OrderInterface } from '../../core/models/order.model';
import { UserInterface } from '../../core/models/user.model';
import { UserService } from '../../core/services/user/user.service';
import { OrdersService } from '../../orders/orders.service';

@Injectable({
  providedIn: 'root',
})
export class OrderNotificationOpenerService {
  private ordersService = inject(OrdersService);
  private userService = inject(UserService);
  private router = inject(Router);

  open(notification: NotificationInterface) {
    this.ordersService
      .getOne(notification.objectId, false)
      .noCache()
      .subscribe((order: OrderInterface) => {
        this.userService.fromStorage().subscribe((user: UserInterface) => {
          this.redirectByOrderStatusAndUserRole(order, user);
        });
      });
  }

  private redirectByOrderStatusAndUserRole(order: OrderInterface, user: UserInterface) {
    this.router.navigate(this.ordersService.getOrderPathByUserAndState(user, order));
  }
}
